<template>
  <section id="about" class="row py-5">
   
    <div class="col-12 col-lg-10 m-auto text-center text-md-start mb-3">
      <h3 class="pageStyleWordLight text-capitalize">
        something about me
      </h3>
    </div>
    <div class="col-12 col-lg-10 m-auto fs-4">
      <p> 
        In my late 20s I decided to turn my life around with Boolean's bootcamp. Before that I had many jobs, most of them in the restaurant industry, particularly as a pizza maker.
      </p> 
      
      <p>
        An Italian guy working as a pizza maker, kinda odd right?
        <br>
        Loved it, but it wasn't the life i've dreamed of.
      </p>

      <p>
        I've always been a curious guy, interested in technology and, as you can see, astronomy and space related stuff.
        <br>
        It was this curiosity that drove me to radically change my lifestyle and become a full stack web developer, making my passions and interests become my job!
      </p>
    </div>
   
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
}
</script>

<style lang="scss" scoped>

@media screen and (max-width: 575.98px) {
    #about{
      min-height: 80vh;
    }
  }

 


</style>